import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { post } from  "@rails/request.js";

// Connects to data-controller="sortable"
export default class extends Controller {
  connect() {
      console.log("sortable controller connected");

      this.sortable = Sortable.create(this.element, {
          animation: 150,
          onEnd: this.onEnd.bind(this)
      })
  }

  onEnd(event) {
      const item = event.item;
      const newIndex = event.newIndex;
      const siblings = Array.from(item.parentNode.children);

      const idToMove = item.dataset.id;
      let otherId;
      let direction
      if (newIndex === 0) {
          // move to the top
          direction = "before"
          otherId = siblings[1].dataset.id; // siblings[1] is the previous first item prior to the move
      } else {
          // move after some other task
          direction = "after"
          otherId = siblings[newIndex - 1].dataset.id;
      }

      const body = JSON.stringify({ direction, other_id: otherId });
      post(`/jobs/${idToMove}/position`, { body }).then(() => {
          // refresh the current row index in the list to reflect any change to the index of the current row
          // caused by the move
          const listController =
              this.application.getControllerForElementAndIdentifier(document.getElementById("itemList"), "list");
          if (listController) {
              listController.refreshCurrentRowIndex();
          }
      });

      console.log("sortable item " + item.dataset.id + " moved " + direction + " " + otherId);
  }

  disconnect() {
      console.log("sortable controller disconnected from", this.element);
      this.sortable.destroy()
  }
}
